export default __webpack_public_path__ + "static/media/tablet_sm.d46320c4.jpg";